import { t } from "../locale";

/**
 * @param {Smartplug} sp
 * @returns {string}
 */
function checkLoadAlarm(sp) {
	if (!sp.LoadAlarm.Enabled) return "";
	if (!sp.LoadAlarm.Triggered) return "";
	if (sp.Load < sp.LoadAlarm.Lower) return t.smartplug.card.lowLoadWarning;
	if (sp.Load > sp.LoadAlarm.Upper) return t.smartplug.card.highLoadWarning;
	return "";
}

/**
 * @param {Smartplug} sp
 * @returns {string}
 */
function checkOfflineAlarm(sp) {
	if (!sp.OfflineAlarm?.Enabled) return "";
	if (!sp.OfflineAlarm.Triggered) return "";
	return t.device.card.connectionWarning;
}

/**
 * @param {Smartplug} sp
 * @returns {string}
 */
function checkPowerFailureAlarm(sp) {
	if (!sp.PowerFailureAlarm.Enabled) return "";
	if (!sp.PowerFailureAlarm.Triggered) return "";
	return t.smartplug.card.powerFailureWarning;
}

/**
 * @param {Smartplug} sp
 * @returns {string}
 */
function checkTemperatureAlarm(sp) {
	if (!sp.TemperatureRangeAlarm.Enabled) return "";
	if (!sp.TemperatureRangeAlarm.Triggered) return "";
	if (sp.Temperature < sp.TemperatureRangeAlarm.Lower)
		return t.smartplug.card.lowTempWarning;
	if (sp.Temperature > sp.TemperatureRangeAlarm.Upper)
		return t.smartplug.card.highTempWarning;
	return "";
}

/**
 * @param {Smartplug} sp
 * @returns {string[]}
 */
function getSmartplugWarnings(sp) {
	return [
		checkLoadAlarm(sp),
		checkOfflineAlarm(sp),
		checkPowerFailureAlarm(sp),
		checkTemperatureAlarm(sp),
	].filter((text) => text !== "");
}

export { getSmartplugWarnings };
